import React from 'react';

import { Box } from '@chakra-ui/react';

import { SaveAndAdd } from 'assets/assetsV1/iconComponents';

import { DrawerFooter } from 'uiToolkitV1/BottomDrawer';
import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip';

export interface FooterProps {
  onClose: () => void;
  onSave: () => void;
  showSecondaryPanel?: boolean;
  saveButtonDisabled?: boolean;
  saveButtonDisabledReason?: string;
}

export const Footer = ({
  onClose,
  onSave,
  showSecondaryPanel,
  saveButtonDisabled,
  saveButtonDisabledReason,
}: FooterProps) => (
  <DrawerFooter h="72px" backgroundColor="neutral.F5F7F9">
    <Button variant="tertiary" mr="auto" onClick={onClose}>
      Cancel
    </Button>
    <Tooltip fontSize="14px" label={saveButtonDisabled ? saveButtonDisabledReason : ''}>
      <Box as="span">
        <Button StartIcon={SaveAndAdd} onClick={onSave} disabled={showSecondaryPanel || saveButtonDisabled}>
          Save
        </Button>
      </Box>
    </Tooltip>
  </DrawerFooter>
);
